import type { PracticeDepth, PracticeDepthMap } from "./depth-types";
import { PRACTICE_DEPTH_A } from "./depth-a";
import { PRACTICE_DEPTH_B } from "./depth-b";

export type { PracticeDepth, PracticeCompare } from "./depth-types";

export const PRACTICE_DEPTH: PracticeDepthMap = {
  ...PRACTICE_DEPTH_A,
  ...PRACTICE_DEPTH_B,
};

export function practiceDepth(slug: string): PracticeDepth | undefined {
  return PRACTICE_DEPTH[slug];
}
